import { ModalTiteledWindow } from "./modalWindow.js";
import { ModalEditCourse } from "./modalEditCourse.js";
import { ModalShowAbsences } from "./modalShowAbsences.js";
import { ModalShowAbsentItemsOfCourse } from "./modalShowAbsentItemsOfCourse.js";

export class ModalCourse extends ModalTiteledWindow {

   constructor(app, course) {
      super();
      this.app = app;
      this.course = course;
      this.addClass('modal-course');
      this.setTitle(`Kurs ${this.course.classNames + ' ' + this.course.short}`);

      let html = `
         <div class="btn flat-button show-pupils">Schülerliste bearbeiten</div>
         <div class="btn flat-button show-absent-homework">Versäumte Hausaufgaben</div>
         <div class="btn flat-button show-absent-material">Vergessene Arbeitsmaterialien</div>
         <div class="btn flat-button show-absences">Fehlstunden</div>
         <a class="btn flat-button" href="${this.app.server}?action=classreg-get&export=class-register-by-courses&format=pdf&courses[]=${course.id}&auth-token=${localStorage.getItem('authToken')}" target="_blank">Meine Klassenbucheinträge (PDF)</a>
      `;

      this.setBody(html);

      if (this.course.classes.length) {
         const cls = this.app.dm.getClass(this.course.classes[0]);
         if (cls.year < 11) {
            this.panel.querySelector('.btn.show-absences').style.display = 'none';
         }
      }


      this.panel.querySelector('.btn.show-pupils').onclick = (event) => {
         event.stopPropagation();
         new ModalEditCourse(course.id, this.app.dm);
      }

      this.panel.querySelector('.btn.show-absent-homework').onclick = (event) => {
         event.stopPropagation();
         new ModalShowAbsentItemsOfCourse('homework', "Versäumte Hausaufgaben", this.app, course.id);
      }

      this.panel.querySelector('.btn.show-absent-material').onclick = (event) => {
         event.stopPropagation();
         new ModalShowAbsentItemsOfCourse('material', "Vergessene Arbeitsmaterialien", this.app, course.id);
      }


      this.panel.querySelector('.btn.show-absences').onclick = (event) => {
         event.stopPropagation();
         new ModalShowAbsences(this.app, 'pupil', { course });
      }


      setTimeout(() => this.show(), 1);

   }

}
